import React from "react";

import { Icon } from "@lululemon/ufs-shared";

import ZoomButton from "../shared/components/zoom-button";

import styles from "./styles/zoom-icon.module.scss";

const ZoomIconComponent = ({ activeSlide, openZoomModal, IconZoom }) => {
  const zoomButtonNamePrefix = "product-media-carousel";
  return (
    <ZoomButton
      buttonClassNames={styles.zoomButton}
      handleZoomButtonClick={openZoomModal}
      isZoomModal={false}
      namePrefix={zoomButtonNamePrefix}
      index={activeSlide}
    >
      <Icon
        glyph={IconZoom}
        className={styles.zoomIcon}
        title="Click to zoom in"
        aria-label="Click to zoom in"
      />
    </ZoomButton>
  );
};

export default ZoomIconComponent;
